import type { SEGNode, SEGToolInputs } from '../components/seg-viewer/seg.types';

/** Newer graphs carry `{ required, anyOf, properties }`; older ones a flat name → var map. */
export function isStructuredInputs(inputs: unknown): inputs is SEGToolInputs {
	return typeof inputs === 'object' && inputs !== null && ('required' in inputs || 'anyOf' in inputs);
}

/** Output field names, whether the graph stored names only or the tool's output schema. */
export function outputNames(outputs: SEGNode['outputs']): string[] {
	if (!outputs) return [];
	return Array.isArray(outputs) ? outputs : Object.keys(outputs);
}
